import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createAccident } from 'repositories/accidente_kinder_repository';

interface AccidenteKinderState {
  loading: boolean;
  error: string | null;
}

const initialState: AccidenteKinderState = {
  loading: false,
  error: null,
};

 
export const agregarAccidente = createAsyncThunk(
  'accidenteKinder/agregarAccidente',
  async (data: Record<string, unknown>, { rejectWithValue }) => {
    try {
      await createAccident(data);
    } catch {
      return rejectWithValue('Error al registrar accidente');
    }
  },
);

export const accidenteKinderSlice = createSlice({
  name: 'accidenteKinder',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(agregarAccidente.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(agregarAccidente.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(agregarAccidente.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default accidenteKinderSlice.reducer;
